var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetSelector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27097 0.183058C7.51352 0.427136 7.51352 0.822864 7.27097 1.06694L4.16563 4.19194C3.92309 4.43602 3.52985 4.43602 3.2873 4.19194L0.181958 1.06694C-0.0605853 0.822864 -0.0605853 0.427136 0.181958 0.183058C0.4245 -0.0610194 0.817739 -0.0610194 1.06028 0.183058L3.72647 2.86612L6.39265 0.183058C6.63519 -0.0610194 7.02843 -0.0610194 7.27097 0.183058Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetSelector);
export default __webpack_public_path__ + "static/media/asset-selector.dbdea08c.svg";
export { ForwardRef as ReactComponent };